import React from "react";
import styles from "../document/document.module.css";
import backgroundImage from "./../../assets/16.09.2022-2-1-2.jpg";

export const Skolisombuts = () => {
  const documentList = [
    {
      name: "ბავშვთა უფლებების ხელშეწყობის და დაცვისთვის",
      filename: "debuleba.pdf",
    },
    {
      name: "სკოლის ბავშვთა ომბუდსმენის ინსტიტუტის პრეზენტაცია",
      filename: "ombudsmeni.pdf",
    },

    {
      name:"ბავშვთა ომბუდსმენის დებულება",
      filename:"ombdebuleba.pdf"
    },
    {
      name:"ბროშურა",
      filename:"broshura.pdf"
    }
  ];

  const backgroundStyle = {
    backgroundImage: `url(${backgroundImage})`,
    backgroundSize: "cover",
    height: "100vh",
  };

  return (
    <div style={backgroundStyle}>
      <div className={styles.documentsPage}>
        <header className={styles.header}>
          <h1>სკოლის ბავშვთა ომბუდსმენი</h1>
        </header>
        <div className={styles.documentsContainer}>
          {documentList.map((doc, index) => (
            <a
              key={index}
              className={styles.documentBox}
              target="_blank"
              rel="noreferrer noopener"
              href={`https://batumi-gimnazia.edu.ge/documents/${doc.filename}`}
            >
              {doc.name}
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};
